import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export const RewardCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  box-shadow: 2px 0px 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  cursor: pointer;
  flex: 1;
  min-width: 264px;
  margin-bottom: 8px;
`;

export const SubContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const Status = styled(Typography)<{ status?: boolean }>`
  margin: 0 auto;
  height: 17px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${(props) => (props.status ? "#954baf" : "#000000")};
`;

export const RemainingQuestions = styled(Typography)<{ status?: string }>`
  /* Remaining Questions */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  gap: 8px;

  height: 25px;

  background: ${(props) => {
    switch (props.status) {
      case "New":
        return "#F4EDF7";
      case "Started":
        return "#F7F7E8";
      case "Completed":
        return "#E6F1E4";
      default:
        return "#F4EDF7"; // Default color (same as 'New')
    }
  }};
  border-radius: 4px;

  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;

  color: ${(props) => {
    switch (props.status) {
      case "New":
        return "#954BAF";
      case "Started":
        return "#B1AB1D";
      case "Completed":
        return "#0A7C00";
      default:
        return "#954BAF"; // Default color (same as 'New')
    }
  }};
`;

export const TitleText = styled(Typography)`
  height: 27px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
`;

export const CategoryIcon = styled(Box)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #525151;
`;
